module.exports = __webpack_public_path__ + "static/media/logo_24.e142aed6.svg";